/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Model, { attr, type SyncHasMany } from '@ember-data/model';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type DynamicContentVariation from 'embercom/models/articles/dynamic-content-variation';

export default class DynamicContent extends Model {
  @attr('string') declare name: string;
  @attr('string') declare key: string;
  @attr('string') declare contentType: string;
  @attr('string') declare defaultLocale: string;
  @attr('number') declare createdById: number;
  @attr('number') declare updatedById: number;
  @attr('date') declare createdAt: Date;
  @attr('date') declare updatedAt: Date;

  @fragmentArray('articles/dynamic-content-variation')
  declare variations: SyncHasMany<DynamicContentVariation>;
}
